import { useState } from "react";
import Flag from "../../../assets/icons/Flag";
import Search from "../../../assets/icons/Search";
import Input from "../../../components/general/Input";

import {
  Title,
  Container,
  TableContainer,
  Table,
  StatusFormat,
  THTarefa,
  THEndingDate,
  THDuration,
  THACC,
  THStartDate,
  THStatus,
  TDTarefa,
  TDEndingDate,
  TaskDate,
  TDDuration,
  TDACC,
  TDStartDate,
  TDStatus,
  TRLine,
  Avatar,
} from "./styles";

const toSearch = (searchTerm) => (item) =>
  item.label.toLowerCase().includes(searchTerm.toLowerCase());

const TasksLister = ({ jobs }) => {
  const [search, setSearch] = useState("");

  const getStatus = (task) => {
    const status = task.status;

    return status === "doing"
      ? "Em execução"
      : status === "pending"
        ? "Pendente"
        : status === "done"
          ? "Concluído"
          : status === "doneLate"
            ? "Concluído com atraso"
            : "Atrasado";
  };

  const numberOfDays = (item) =>
    item.duration.number === 24
      ? item.duration.number / 24 + " dia"
      : item.duration.number / 24 + " dias";

  const SearchList = jobs.filter(toSearch(search));

  return (
    <>
      <Container>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Title>Tarefas do Fluxo</Title>
          <Input
            style={{ width: "15rem", background: "#eee" }}
            Icon={() => <Search />}
            placeholder="Pesquisar por Titulo..."
            value={search}
            setValue={setSearch}
          />
        </div>
        <TableContainer>
          <Table>
            <thead className="table-head">
              <tr className="first-line">
                <THTarefa>Tarefa</THTarefa>
                <THStartDate>Data de Inicio</THStartDate>
                <THDuration>Duração</THDuration>
                <THEndingDate>Data de Conclusão</THEndingDate>
                <THStatus>Status</THStatus>
                <THACC>Responsável</THACC>
              </tr>
            </thead>
            <tbody>
              {SearchList.map((item) =>
                item.type === "task" ? (
                  <TRLine key={Math.random()}>
                    <TDTarefa>{item.label}</TDTarefa>
                    <TDStartDate>
                      {item.start.toLocaleDateString("pt-BR", {
                        day: "numeric",
                        month: "long",
                      })}
                    </TDStartDate>
                    <TDDuration>{numberOfDays(item)}</TDDuration>
                    <TDEndingDate>
                      <TaskDate status={item.status}>
                        <Flag />
                        {item.end.toLocaleDateString("pt-BR", {
                          day: "numeric",
                          month: "long",
                        })}
                      </TaskDate>
                    </TDEndingDate>
                    <TDStatus>
                      <StatusFormat status={item.status}>
                        {getStatus(item)}
                      </StatusFormat>
                    </TDStatus>
                    <TDACC>
                      <Avatar
                        src={
                          item.accountable
                            ? item.accountable.avatarURL
                            : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAADsAAAA7AF5KHG9AAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAllJREFUWIXFlr9PVEEQxz/e6VkcnLGVxhilEBLkD5BCBDujxNz/IAERS0OPWNhoLLQ1SEIsbYmKNEYbOeP5s9EYNWhCsJEEsNjZvL3N7r7H7lO/yeYlM9/Z+b6dnXkPdoca0ATmgTbwS1ZbbE3h/BWMAR+AnZz1HjhfZuIKcN1IsApMAX1AXVaf2FYN3pzEJkMn/w2M52xaBSaEq0UkYcxIfsqwN4DbwBdgDVgAegz/sCHiXGzyGlnNxw17BVjBXfuGwZsU+ztgX4yAJlnNq4Z9SOwfgWPAYeCl2C4avCrQEvuFGAH3JfiSZd8PXAUGDNtl4d6wuNNivxcj4I0EH8/h1YHHwp2wfP1ib8cI2JDgrgDnCKr2O8An4KDl7xbfRoqA7gDnoXBeoO6DjYb412MEFCnBmnAOefy5JQgNlefyHA1wWiihXz3+M/J8FtjDC92GLTrb0IbvJarAKxLasEZ2wezbrbECLHt8UxL7lshBBOqrpkfxsMO/DDxx2E8Dm8A2cDY2ucacIWKScDn2ot58U2JmU5ODqrEWoe/ENOqGd8nqB66Q1XwbuEZJn+MR4C7wGdgyhPjWFmoo3UGVIhq9ZCM2ZT3CPaSCGAJ+ygbfgBngBGru56EODErMd9njB3CyaPJeI/ki4VGchwbwwBBxtEiQPvZFYE9Cco2KIWIpjzxCduwpb27jAFk5OuaJ3SZNed4k8hPqwTpwy8rhRBulcsCyh0auCy7+oOz9OhTo+wnRLVUULn6hnxNfojIEOO2ljMoU/HcBdp/v5phLyWufwNN/kLyjO/4AEWrQwym30uMAAAAASUVORK5CYII="
                        }
                      />
                      {item.accountable?.username
                        ? item.accountable?.username?.split(" ")[0]
                        : " - - - "}
                    </TDACC>
                  </TRLine>
                ) : null,
              )}
            </tbody>
          </Table>
        </TableContainer>
      </Container>
    </>
  );
};

export default TasksLister;
